export const UB_OPTANON_ALERT_BOX_CLOSED_COOKIE_NAME = "OptanonAlertBoxClosed"
export const UB_FF_SESSION_COOKIE_NAME = "ubffsession"
export const UB_FF_USER_ID_COOKIE_NAME = "ubffuserid"
export const UB_FORCE_OCI_COOKIE = "ub_force_oci"
export const UB_PUNCHOUT_SESSION_COOKIE_NAME = "ubPunchoutSession"
export const UB_PUNCHOUT_SESSION_COOKIE_EXPIRATION =
  "ubPunchoutSession=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;"

export const SYNCHRONIZER_TOKEN_COOKIE_NAME = "synchronizerToken"
export const SID_COOKIE_NAME = "sid"
export const INTERSHOP_APITOKEN_COOKIE_NAME = "apiToken"
export const RECENTLY_VIEWED_PRODUCTS_COOKIE_NAME = "ubRecentlyViewedProducts"
export const RECENTLY_VIEWED_PRODUCTS_SEPARATOR = "|"

export const NEXT_HEADER_URL_KEY = "x-url-for-next"
export const NEXT_HEADER_SB_LOCALE = "x-sblocale-for-next" // see also next.config
export const NEXT_HEADER_ACCESS_TOKEN = "x-access-token-for-next"
export const INTERNAL_MARKET_ROUTE_SECRET_HEADER = "x-ub-internal-market-secret"
export const HANDLING_FEE_THRESHOLD = 50.0

export const UB_LOGIN_REDIRECT_URL_COOKIE_NAME = "ubLoginRedirectUrl"
export const UB_LOGIN_REDIRECT_URL_PARAM_NAME = "loginRedirectUrl"
export const UB_LOGIN_REDIRECT_URL_DEFAULT = "/account"

export const X_BOT_DETECTED_HEADER_VAR = "X-Bot-Detected"
export const X_OCI_HEADER_VAR = "X-Oci"

export const APP_B2B_BUYER = "APP_B2B_BUYER"
export const APP_B2B_ACCOUNT_OWNER = "APP_B2B_ACCOUNT_OWNER"
export const APP_B2B_OCI_ACCOUNT_OWNER = "APP_B2B_OCI_ACCOUNT_OWNER"
export const APP_B2B_COSTCENTER_OWNER = "APP_B2B_COSTCENTER_OWNER"
export const APP_B2B_APPROVER = "APP_B2B_APPROVER"
export const APP_B2B_COSTOBJECT_MANAGER = "APP_B2B_COSTOBJECT_MANAGER"
export const APP_B2B_OCI_USER = "APP_B2B_OCI_USER"

export const APP_B2B_SEND_PUNCHOUT_BASKET = "APP_B2B_SEND_PUNCHOUT_BASKET"

export const LINE_OF_BUSINESSES = ["000", "100", "200", "300", "400", "500", "600", "700", "800", "900"]
